import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { login } from "../../../Services/userService";
import Background from "../../Background";
import IndexNav from "../../IndexNav";
import {
  BgContainer,
  Container,
  FormSection,
  FormCard,
  Form,
  Title,
  Subtitle,
  Input,
  Button,
  Helper,
  Hr,
  Link,
} from "./Styled";

const Login = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [userInformations, setUserInformations] = useState({
    email: "",
    password: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    login(userInformations, dispatch);
  };

  return (
    <>
      <IndexNav />
      <BgContainer>
        <Background />
      </BgContainer>
      <Container>
        <FormSection>
          <FormCard>
            <Form onSubmit={handleSubmit}>
              <Title>Welcome back</Title>
              <Subtitle>Log in to access your boards, tasks, and team activity.</Subtitle>
              <Link fontSize="0.8rem" onClick={() => history.push("/")}>
                Back to home
              </Link>
              <Input
                type="email"
                placeholder="Work email"
                required
                value={userInformations.email}
                onChange={(e) =>
                  setUserInformations({
                    ...userInformations,
                    email: e.target.value,
                  })
                }
              />
              <Input
                type="password"
                placeholder="Password"
                required
                value={userInformations.password}
                onChange={(e) =>
                  setUserInformations({
                    ...userInformations,
                    password: e.target.value,
                  })
                }
              />
              <Button>Log in</Button>
              <Helper>Use the account you created for PepHub Board.</Helper>
              <Hr />
              <Link fontSize="0.85rem" onClick={() => history.push("/register")}>
                New to PepHub Board? Create an account
              </Link>
            </Form>
          </FormCard>
        </FormSection>
      </Container>
    </>
  );
};

export default Login;
